module.exports = __webpack_public_path__ + "img/n2.2da096bd.png";